class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.searchParams = '';
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    this.searchParams = searchParams;
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const productGrid = document.getElementById('ProductGridContainer');
    productGrid?.querySelector('.collection')?.classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    setTimeout(function () {
      if (window.customHulkAw && typeof window.customHulkAw.init === 'function') {
        window.customHulkAw.init();
      }
    }, 800);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        document.dispatchEvent(new CustomEvent('facets:rendered'));
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    document.dispatchEvent(new CustomEvent('facets:rendered'));
  }

  static clearHTML (innerHTML, searchParams=''){
    
    let label = document.querySelectorAll('.label_count');
    label.forEach((elem) => {
      let label_count = elem.innerHTML;
      let label_elem = elem.getAttribute("data-label");
      const target = document.getElementById(label_elem);
      if (!target) return;
      if (label_count != 0) {
        target.innerHTML = '(' + label_count + ')';
      } else {
        target.innerHTML = '';
      }
    });
    return innerHTML;
  }

  static scrollToCollectionTop() {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    const target = container.closest('.collection') || container;

    const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper') || document.querySelector('header');
    const headerHeight = header && header.offsetHeight ? header.offsetHeight : 0;

    const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;

    const clamped = Math.max(0, Math.floor(top));
    window.scrollTo({ top: clamped, behavior: 'smooth' });
  }

  static renderProductGridContainer(html) {
    let newInnerHTML = new DOMParser().parseFromString(html, 'text/html');
    newInnerHTML = FacetFiltersForm.clearHTML(newInnerHTML, FacetFiltersForm.searchParams)
    const productGridContainer = document.getElementById('ProductGridContainer');
    productGridContainer.innerHTML = newInnerHTML
        .getElementById('ProductGridContainer')?.innerHTML;
    productGridContainer.classList.add('scroll-trigger--cancel');
    productGridContainer
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    requestAnimationFrame(() => FacetFiltersForm.scrollToCollectionTop());

    if (typeof window.initCollectionAjaxinate === 'function') window.initCollectionAjaxinate();
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const countEl = parsed.getElementById('ProductCount') || parsed.getElementById('ProductCountDesktop');
    if (!countEl) return;

    const count = countEl.innerHTML;

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const index = element.dataset.index;
      const formRoot = element.closest('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetFiltersPillsForm');
      if (!formRoot || index === undefined) return;
      const target = formRoot.querySelector(`.js-filter[data-index="${index}"]`);
      if (target) target.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event) {
      const targetFilter = event.target.closest('.js-filter');
      if (targetFilter) FacetFiltersForm.renderCounts(countsToRender, targetFilter);
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
      
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: (document.getElementById('product-grid') || document.getElementById('product-grid-main')).dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    dataGoTrackFacetChange(event);
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    dataGoTrackFacetRemoval(event);
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
  
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.clearHTML(document, FacetFiltersForm.searchParamsInitial );

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class CollectionToolbar extends HTMLElement {
  #gridTop = 0;
  #grid = null;
  #resizeObserver = null;

  connectedCallback() {
    this.lastScrollY = window.scrollY || 0;
    this.#grid = document.getElementById('ProductGridContainer');

    this.onScroll = this.onScroll.bind(this);

    this.#cacheGridTop();

    this.#resizeObserver = new ResizeObserver(() => this.#cacheGridTop());
    this.#resizeObserver.observe(document.documentElement);

    window.addEventListener('scroll', this.onScroll, { passive: true });

    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.#resizeObserver?.disconnect();
    this.#resizeObserver = null;
    this.#grid = null;
  }

  #cacheGridTop() {
    this.#gridTop = this.#grid ? this.#grid.getBoundingClientRect().top + (window.scrollY || 0) : 0;
  }

  onScroll() {
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    const delta = scrollY - this.lastScrollY;

    const facetsDrawer = this.querySelector('.mobile-facets__disclosure');
    if (facetsDrawer?.hasAttribute('open')) {
      this.lastScrollY = scrollY;
      return;
    }

    if (scrollY < this.#gridTop) {
      this.classList.remove('collection__toolbar--hidden');
      this.lastScrollY = scrollY;
      return;
    }

    const style = document.documentElement.style;
    const headerHeight = parseInt(style.getPropertyValue('--header-height')) || 0;
    const announcementHeight = parseInt(style.getPropertyValue('--announcement-bar-height')) || 0;
    const scrollGap = 24;
    const collectionOffset = this.#gridTop + headerHeight + announcementHeight + scrollGap;

    if (scrollY <= collectionOffset) {
      this.classList.remove('collection__toolbar--hidden');
      this.lastScrollY = scrollY;
      return;
    }

    this.classList.toggle('collection__toolbar--hidden', delta > 0);

    this.lastScrollY = scrollY;
  }
}

customElements.define('collection-toolbar', CollectionToolbar);

window.initCollectionAjaxinate = function initCollectionAjaxinate() {
  const state = (window.__collectionInfiniteState ||= {
    io: null,
    sentinel: null,
    inFlight: false,
    requested: new Set(),
    mode: null,
    _scrollHandler: null,
    _scrollRaf: 0,
  });

  const hasMainGrid = !!document.querySelector('#product-grid-main');
  const hasMainPag = !!document.querySelector('#AjaxinatePagination-main');
  const hasDefaultGrid = !!document.querySelector('#product-grid');
  const hasDefaultPag = !!document.querySelector('#AjaxinatePagination');

  const mode = (hasMainGrid && hasMainPag)
    ? 'main'
    : (hasDefaultGrid && hasDefaultPag)
      ? 'default'
      : null;

  if (state.mode !== mode) {
    state.requested = new Set();
    state.mode = mode;
  }

  if (!mode) {
    if (state._scrollHandler) {
      window.removeEventListener('scroll', state._scrollHandler, { passive: true });
      window.removeEventListener('resize', state._scrollHandler);
      state._scrollHandler = null;
    }
    if (state._scrollRaf) {
      cancelAnimationFrame(state._scrollRaf);
      state._scrollRaf = 0;
    }
    if (state.io) try { state.io.disconnect(); } catch (e) {}
    state.io = null;
    if (state.sentinel) state.sentinel.remove();
    state.sentinel = null;
    state.inFlight = false;
    return;
  }

  const gridSel = mode === 'main' ? '#product-grid-main' : '#product-grid';
  const pagSel = mode === 'main' ? '#AjaxinatePagination-main' : '#AjaxinatePagination';

  const grid = document.querySelector(gridSel);
  const pag = document.querySelector(pagSel);
  if (!grid || !pag) return;

  function rawNextHref() {
    const a = pag.querySelector('a[href]');
    return a ? a.getAttribute('href') : null;
  }

  function buildNextHrefPreservingParams(rawHref) {
    if (!rawHref) return null;
    try {
      const linkUrl = new URL(rawHref, window.location.origin);
      const currentUrl = new URL(window.location.href);
      const nextPage = linkUrl.searchParams.get('page');

      const merged = new URL(currentUrl.pathname + currentUrl.search, window.location.origin);
      if (nextPage) merged.searchParams.set('page', nextPage);

      const sort = currentUrl.searchParams.get('sort_by');
      if (sort && !merged.searchParams.get('sort_by')) merged.searchParams.set('sort_by', sort);

      return merged.pathname + '?' + merged.searchParams.toString();
    } catch (e) {
      return rawHref;
    }
  }

  function existingProductHrefs() {
    return new Set(
      Array.from(grid.querySelectorAll('a[href*="/products/"]')).map((a) => a.getAttribute('href'))
    );
  }

  async function loadMore() {
    if (state.inFlight) return;

    const rawHref = rawNextHref();
    if (!rawHref) return;

    const href = mode === 'main' ? buildNextHrefPreservingParams(rawHref) : rawHref;
    if (!href) return;

    if (state.requested.has(href)) return;
    state.requested.add(href);

    state.inFlight = true;
    grid.setAttribute('aria-busy', 'true');

    const loaderSvg = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_83_17743)">
        <circle cx="25.299" cy="24.75" r="19.5" transform="rotate(-60 25.299 24.75)" stroke="#A8A8A8"/>
        <circle cx="8.84496" cy="15.25" r="4" transform="rotate(-60 8.84496 15.25)" fill="#A8A8A8"/>
      </g>
      <defs><clipPath id="clip0_83_17743"><rect width="48" height="48" fill="white"/></clipPath></defs>
    </svg>`;

    const prevPagHtml = pag.innerHTML;
    pag.innerHTML = `<div class="collection-infinite-loader" style="display:flex;justify-content:center;padding:16px 0;">${loaderSvg}</div>`;

    try {
      const sectionId = grid.dataset && grid.dataset.id ? grid.dataset.id : null;
      const url = new URL(href, window.location.origin);

      if (sectionId) {
        url.searchParams.set('section_id', sectionId);
      }

      const res = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error('Bad response: ' + res.status);

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector(gridSel);
      const newPag = doc.querySelector(pagSel);

      const newItems = newGrid ? Array.from(newGrid.querySelectorAll(':scope > li')) : [];
      if (!newItems.length) {
        pag.innerHTML = '';
        return;
      }

      const existing = existingProductHrefs();
      newItems.forEach((li) => {
        const productLink = li.querySelector && li.querySelector('a[href*="/products/"]');
        const productHref = productLink ? productLink.getAttribute('href') : null;
        if (productHref && existing.has(productHref)) return;
        if (productHref) existing.add(productHref);
        grid.appendChild(li);
      });

      pag.innerHTML = newPag ? newPag.innerHTML : '';

      attachObserver();
      attachScrollEndTrigger();
    } catch (e) {
      console.error('[collection infinite] loadMore error', e);
      state.requested.delete(href);
      pag.innerHTML = prevPagHtml;
    } finally {
      state.inFlight = false;
      grid.removeAttribute('aria-busy');
    }
  }

  function attachObserver() {
    if (!rawNextHref()) {
      if (state.io) try { state.io.disconnect(); } catch (e) {}
      state.io = null;
      if (state.sentinel) state.sentinel.remove();
      state.sentinel = null;
      return;
    }

    if (!state.sentinel || !state.sentinel.isConnected) {
      state.sentinel = document.createElement('div');
      state.sentinel.setAttribute('data-collection-infinite-sentinel', mode);
      state.sentinel.style.height = '1px';
      pag.after(state.sentinel);
    }

    if (state.io) try { state.io.disconnect(); } catch (e) {}

    state.io = new IntersectionObserver(
      (entries) => {
        const entry = entries && entries[0];
        if (!entry || !entry.isIntersecting) return;
        if (state.inFlight) return;

        try { state.io.disconnect(); } catch (e) {}
        loadMore();
      },
      { rootMargin: '0px 0px 50px 0px' }
    );

    state.io.observe(state.sentinel);
  }
  function attachScrollEndTrigger() {
    if (!rawNextHref()) {
      if (state._scrollHandler) {
        window.removeEventListener('scroll', state._scrollHandler, { passive: true });
        window.removeEventListener('resize', state._scrollHandler);
        state._scrollHandler = null;
      }
      return;
    }
    if (state._scrollHandler) {
      window.removeEventListener('scroll', state._scrollHandler, { passive: true });
      window.removeEventListener('resize', state._scrollHandler);
      state._scrollHandler = null;
    }

    state._scrollHandler = function () {
      if (state._scrollRaf) return;
  
      state._scrollRaf = requestAnimationFrame(() => {
        state._scrollRaf = 0;
  
        if (state.inFlight) return;
        if (!rawNextHref()) return;
  
        const collectionEl = grid.closest('.collection');
        if (!collectionEl) return;

        const viewportBottom = window.scrollY + window.innerHeight;
        const collectionBottom = collectionEl.offsetTop + collectionEl.offsetHeight;

        if (viewportBottom >= (collectionBottom - 120)) {
          loadMore();
        }
      });
    };
  
    window.addEventListener('scroll', state._scrollHandler, { passive: true });
    window.addEventListener('resize', state._scrollHandler);
  }

  attachObserver();
  attachScrollEndTrigger();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    window.initCollectionAjaxinate();
  });
} else {
  window.initCollectionAjaxinate();
}

window.addEventListener('load', function () {
  if (typeof window.initCollectionAjaxinate === 'function') window.initCollectionAjaxinate();
});

document.addEventListener("DOMContentLoaded", (event) => {
  let btn_close = document.querySelector('.facets_close_btn'),
      menu = document.querySelector('.mobile-facets__disclosure.disclosure-has-popup'),
      parent = document.querySelector('.mobile-facets__wrapper'),
      apply_btn = document.querySelector('.facets_apply_btn');
  btn_close.addEventListener('click', function() {
    menu.classList.remove('menu-opening');
    setTimeout(function() {
      menu.removeAttribute('open');
      document.body.classList.remove(`overflow-hidden-${parent.dataset.breakpoint}`);
    }, 150)
  });
  apply_btn.addEventListener('click', function() {
    menu.classList.remove('menu-opening');
    setTimeout(function() {
      menu.removeAttribute('open');
      document.body.classList.remove(`overflow-hidden-${parent.dataset.breakpoint}`);
    }, 150)
  });
});

/* -------------------------------------------------------------------------
 * DataGo filter events
 * ---------------------------------------------------------------------- */

/**
 * Visible text of an element, without screen reader only labels or counts.
 * Active filter chips and filter headers both carry `.visually-hidden` spans
 * ("Remove filter", "Filter and sort") that must not leak into reported values.
 *
 * @param {Element} element
 * @returns {string|null}
 */
function dataGoVisibleText(element) {
  const clone = element.cloneNode(true);
  for (const noise of clone.querySelectorAll('.visually-hidden, .label_count, [id^="facet-count"]')) {
    noise.remove();
  }

  const label = clone.textContent
    .replace(/\s+/g, ' ')
    .replace(/\(\d+\)/g, '')
    .trim();

  return label || null;
}

/**
 * The group a filter input belongs to, and its visible name.
 *
 * The name comes from the group's own label rather than Shopify's parameter, so
 * it reads as `size` / `color` / `price` instead of
 * `filter.p.m.variants.availability` — and it keeps working if filters are added.
 *
 * @param {Element} input
 * @returns {{group: Element|null, name: string|null}}
 */
function dataGoFilterGroup(input) {
  const group = input.closest('.js-filter, .mobile-facets__filter-group, details');
  if (!group) return { group: null, name: null };

  const label = group.querySelector('legend, summary');
  const name = label ? dataGoVisibleText(label) : null;

  return { group, name: name ? name.toLowerCase() : null };
}

/**
 * Every value currently selected in a group, so the event reports the resulting
 * state as an array rather than the single control that was touched.
 *
 * @param {Element|null} group
 * @param {string} inputName
 * @returns {string[]}
 */
function dataGoSelectedValues(group, inputName) {
  const scope = group || document;
  const selector = `input[name="${inputName}"]:checked`;

  return Array.from(scope.querySelectorAll(selector)).map((input) => input.value);
}

/**
 * Emits `filter_set` when a filter value is applied from the filter form, and
 * `filter_off` when one is unchecked. Sorting is reported as `sort`.
 *
 * @param {Event} [event] - Input event behind the facet update.
 */
function dataGoTrackFacetChange(event) {
  const input = event && event.target;
  if (!window.DataGo || !input || !input.name) return;

  const isSort = input.name === 'sort_by';
  const { group, name } = isSort ? { group: null, name: 'sort' } : dataGoFilterGroup(input);
  const clearing = input.type === 'checkbox' && !input.checked;
  const values = isSort ? [input.value] : dataGoSelectedValues(group, input.name);

  window.DataGo.push(clearing && !values.length ? 'filter_off' : 'filter_set', {
    filter_name: name || input.name,
    filter_value: clearing && !values.length ? [input.value] : values,
  });
}

/**
 * Emits `filter_off` when an active filter chip is dismissed. Chips read
 * "<group>: <value>", so the two halves are recovered from the label.
 *
 * @param {Event} event - Click event on the chip.
 */
function dataGoTrackFacetRemoval(event) {
  if (!window.DataGo) return;

  const chip = event.currentTarget || event.target;
  const [name, value] = (dataGoVisibleText(chip) || '').split(':');

  window.DataGo.push('filter_off', {
    filter_name: name ? name.trim().toLowerCase() : null,
    filter_value: value ? [value.trim()] : [],
  });
}

// `filter_click` is opening the filter UI, before any value is chosen.
//
// The opener is detected from the `toggle` event rather than a click: this theme
// renders the drawer variant of the facets at every breakpoint, and the drawer
// manages the `open` attribute asynchronously, so a click handler cannot tell
// opening from closing. `toggle` does not bubble, hence the capture phase.
document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open || !window.DataGo) return;
    if (!details.closest('.facets-container, .facets-wrapper')) return;

    // A single filter group names itself. The drawer opener is not a group — its
    // summary is a bundle of duplicated responsive labels, counts and a remove
    // button — so opening the panel is reported without a name.
    const isGroup = details.classList.contains('js-filter') || details.hasAttribute('data-index');
    const summary = details.querySelector('summary');

    window.DataGo.push('filter_click', {
      filter_name: isGroup && summary ? dataGoVisibleText(summary) : null,
      filter_value: null,
    });
  },
  true
);

// Filter groups inside the drawer are fieldsets rather than details, so opening
// one is still read from the click on its legend.
document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;

    const legend = event.target.closest('.mobile-facets__close-button');
    if (!legend || !window.DataGo) return;

    window.DataGo.push('filter_click', {
      filter_name: dataGoVisibleText(legend),
      filter_value: null,
    });
  },
  true
);
